import { onMounted, onUnmounted, reactive } from "vue";
import type { IMonitorSize } from "~/shared/interfaces/composables";

export function useMonitorSize(): IMonitorSize {
  const viewport  = useViewport()
  const sizes = reactive<IMonitorSize>({
    browserWidth: viewport.isLessThan('desktop'),
    isMobile: false,
  })


  const browserResized = () => {
    sizes.browserWidth = globalThis.innerWidth
    sizes.isMobile = viewport.isLessThan('desktop')
  }

  onMounted(() => {
    globalThis.addEventListener('resize', browserResized)
  })

  onUnmounted(() => {
    globalThis.removeEventListener('resize', browserResized)
  })

  browserResized();

  return sizes
}
